import InternCoursePage from '../InternCoursePage';
import useInternCourses from '../../../../hooks/useInternCourses';

export default function InternTCEAcademyPage() {
  const { courses, loading, error, reload } = useInternCourses('tceacademy');
  return (
    <InternCoursePage
      courses={courses}
      loading={loading}
      error={error}
      pageTitle={'TCE-Academy'}
      category={'tceacademy'}
      reload={reload}
    />
  );
}
